module.exports = __webpack_public_path__ + "img/app_qrcode.7524bd52.png";